import {createAction, createReducer} from '@reduxjs/toolkit';
import {getActionNameString} from "../../actionLoader";
import {get} from "lodash-es";
import {INVALID_ACTION_TYPE_ERROR} from "../../actionError";

const MODULE_PREFIX = '[ SCRIP DETAILS ACTION ERROR ]';

const getId = (actionName, screenId) => {
	const actionNameString = getActionNameString(actionName);
	return `${actionNameString}_${screenId}`;
};

const Actions = {
	setScripDetailsActionError: `${MODULE_PREFIX} setScripDetailsActionError`,
	resetScripDetailsActionError: `${MODULE_PREFIX} resetScripDetailsActionError`,
};

// actions
export const setScripDetailsActionError = createAction(
	Actions.setScripDetailsActionError,
);

export const resetScripDetailsActionError = createAction(
	Actions.resetScripDetailsActionError,
);

export const getScripDetailsActionError = (state = {}, actionName = '', screenId = '') => {
	const key = getId(actionName, screenId);
	return state.scripDetailsActionLoader[key] || {};
};

// selectors
const initialState = {};

// reducer
export default createReducer(initialState, (builder) => {
	builder.addCase(setScripDetailsActionError, (state, action) => {
		const {actionName, screenId} = action.payload;
		const key = getId(actionName, screenId);
		const isFetchFailed = get(action, 'payload.isFetchFailed', false);
		const isUploadFailed = get(action, 'payload.isUploadFailed', false);
		const message = get(action, 'payload.message', false);
		state[key] = {
			isFetchFailed,
			isUploadFailed,
			message,
		};
	});
	builder.addCase(resetScripDetailsActionError, (state, action) => {
		const {actionName, screenId} = action.payload;
		const key = getId(actionName, screenId);
		delete state[key];
	});
});
